import React from "react";

import Link from "@material-ui/core/Link";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import CheckIcon from "@material-ui/icons/Check";
import CodeIcon from "@material-ui/icons/Code";
import EmailIcon from "@material-ui/icons/Email";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import PropTypes from "prop-types";

import RbFlexView from "components/RbFlexView";
import RbFlexViewItem from "components/RbFlexViewItem";
import RbHeader from "components/RbHeader";
import RbScrollView from "components/RbScrollView";

function AuthorScreen() {
  return (
    <RbFlexView direction="column">
      <RbFlexViewItem>
        <RbHeader title="Author" />
      </RbFlexViewItem>
      <RbFlexViewItem
        flex="1"
        bgcolor="custom.bg.100"
        borderTop={1}
        borderColor="custom.border.200"
      >
        <RbScrollView p={{ xs: 4, md: 10 }}>
          <Typography variant="body1">
            Rui Hiroshi Banki is a Front End Developer with a great passion for
            UI. With more than 15 years of experience has created all sort of
            applications with Javascript, HTML and CSS. Has beeb working with
            React in the past 6 years, always dedicating to deliver great
            products.
          </Typography>
          <br />
          <List dense>
            <ListItemLink
              Icon={GitHubIcon}
              text="GitHub"
              href="https://github.com/ruihbanki"
            />
            <ListItemLink
              Icon={LinkedInIcon}
              text="LinkedIn"
              href="https://www.linkedin.com/in/ruihbanki/"
            />
            <ListItemLink
              Icon={CodeIcon}
              text="CodeSandbox"
              href="https://codesandbox.io/u/ruihbanki"
            />
            <ListItemLink
              Icon={EmailIcon}
              text="Email"
              href="maito:ruihbanki@gmail.com"
            />
          </List>
        </RbScrollView>
      </RbFlexViewItem>
    </RbFlexView>
  );
}

function ListItemLink({ Icon = CheckIcon, text, href }) {
  return (
    <Link href={href} target="_blank">
      <ListItem>
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
        <ListItemText primary={text} />
      </ListItem>
    </Link>
  );
}

ListItemLink.propTypes = {
  Icon: PropTypes.object.isRequired,
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default React.memo(AuthorScreen);
